import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldCheck, Mail, Phone, IdCard } from "lucide-react";
import { toast } from "sonner";
import ShreedhaniRankCard from "@/components/ShreedhaniRankCard";

export default function Profile() {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <div className="pt-6">
      <div className="text-xs font-bold tracking-[0.22em] uppercase text-brand-primary">Profile</div>
      <h1 className="mt-1 font-display text-4xl font-semibold text-brand-cream">{user.name}</h1>

      <div className="mt-6">
        <ShreedhaniRankCard />
      </div>

      <div className="mt-6 rounded-3xl border border-brand-line bg-brand-sand p-5 shadow-soft space-y-3">
        <Row Icon={Mail} label="Email" value={user.email} />
        <Row Icon={Phone} label="Phone" value={user.phone} />
        <Row Icon={IdCard} label="KYC" value={user.kyc_status} accent={user.kyc_status === "VERIFIED"} />
      </div>

      <div className="mt-6 rounded-3xl border border-brand-line-faint bg-brand-sand2 p-5 shadow-soft">
        <div className="flex items-center gap-2 text-brand-cream">
          <ShieldCheck className="text-brand-secondary" size={18} />
          <div className="font-semibold">Trust & Security</div>
        </div>
        <p className="mt-2 text-sm text-brand-slate">
          Your holdings are 100% insured and stored in MMTC-PAMP / Augmont vaults. Withdraw anytime.
        </p>
      </div>

      <Button
        data-testid="profile-logout"
        onClick={() => { logout(); toast.success("Signed out"); }}
        variant="outline"
        className="mt-6 mb-4 w-full h-12 rounded-full border-brand-primary text-brand-primary bg-transparent hover:bg-brand-primary hover:text-brand-page"
      >
        <LogOut size={16} className="mr-2" /> Sign out
      </Button>
    </div>
  );
}

function Row({ Icon, label, value, accent }) {
  return (
    <div className="flex items-center gap-3">
      <div className="h-10 w-10 rounded-full bg-brand-sand2 border border-brand-line-faint flex items-center justify-center">
        <Icon size={16} className="text-brand-primary" />
      </div>
      <div className="flex-1">
        <div className="text-xs uppercase tracking-wider text-brand-slate">{label}</div>
        <div className={`font-semibold text-brand-cream ${accent ? "text-brand-secondary" : ""}`}>{value}</div>
      </div>
    </div>
  );
}
